import { CustomizeValue as ProductCustomizeValue } from "@interfaces/dto/product-detail.dto";

interface Props {
  varient: ProductCustomizeValue;
  selectedVarientSku: string;
  isChecked: boolean;
  onSelectedVarientChange: (sku: string) => void;
}

const ProductConfiguration = ({
  varient,
  selectedVarientSku,
  isChecked,
  onSelectedVarientChange,
}: Props) => {
  console.log(selectedVarientSku, varient.sku);
  return (
    <>
      <input
        key={varient.sku + "i"}
        type="checkbox"
        className={`btn-check`}
        id={varient.sku}
        autoComplete="off"
        disabled={!varient.stocks[0].saleable}
        checked={isChecked}
        value={varient.sku}
        onChange={(e) => onSelectedVarientChange(e.target.value)}
      />
      <label
        key={varient.sku + "l"}
        className={`btn px-2 px-sm-4 me-1 me-sm-2 ${
          selectedVarientSku === varient.sku
            ? "btn-outline-dark"
            : "btn-outline-secondary"
        }`}
        htmlFor={varient.sku}
      >
        {varient.text}
      </label>
    </>
  );
};

export default ProductConfiguration;
